angular.module('leftPaneModule')
.controller('LeftPaneGradeController', ['$scope', '$rootScope', '$state', 'gradeApi', 'cancelableResourceManager', function($scope, $rootScope, $state, $gradeApi, $cancelableResourceManager) {

  var updateGradeData = function() {
    var params = $state.params;
    var promise = $gradeApi.getGradeData(params.gradeId, function(data) {
      $scope.gradeData = data;
      $rootScope.$broadcast('updateYears', data.years);
    });
    $cancelableResourceManager.add(promise);
  };

  var initializeData = function(e, item) {
    $scope.item = item;
    updateGradeData();
  };

  $scope.$on('itemReady', initializeData);
}]);
